import { Component, OnInit } from '@angular/core';
import { MaterialModule } from 'src/app/Shared/Material/material.module';

@Component({
    selector: 'app-base64',
    templateUrl: './base64.component.html',
    styleUrls: ['./base64.component.scss'],
    standalone: false
})
export class Base64Component implements OnInit {
  firstone;
  constructor() { }
  ngOnInit() { }

  convert(form: any) {
    if (form.first == null || form.first == undefined || form.first != "") {
      const linkSource = 'data:application/pdf;base64,' + form.first.trim();
      let namefile = "sample";
      let fileName = namefile + ".pdf";
      const downloadLink = document.createElement("a");
      downloadLink.setAttribute("type", "hidden");
      downloadLink.download = fileName;
      downloadLink.href = linkSource;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
  
    } else {
      
      return;
    }

  }

}
